module.exports = __webpack_public_path__ + "static/dp-princip-7-eda0014eb9d067aa5f346a1a7d2c3e53.svg";